import { request } from './request';

export const getAllPsadReps = () => {
  return request('psad_reps');
};

export const getPsadRepById = (id) => request(`psad_reps/${id}`);

export const createPsadRep = (body) =>
  request(
    `psad_reps`,
    {
      method: 'POST',
      body,
    },
    'Invitation link was sent to the user!',
  );

export const updatePsadRep = (data) =>
  request(
    `psad_reps/${data.id}`,
    {
      method: 'PATCH',
      body: data,
    },
    'PSAD representative updated successfully!',
  );
